module.exports = __webpack_public_path__ + "img/bin.285ddc67.svg";